/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { makeStyles, Typography } from '@material-ui/core';

import IconFaq from '../../assets/images/ic-faq-darkblue.svg';
import IconMessage from '../../assets/images/ic-message-darkblue.svg';
import IconPhone from '../../assets/images/ic-phone-darkblue.svg';

const useStyles = makeStyles((theme) => ({
  rightFaqTitle: {
    color: '#172B4D',
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '30px',
    marginBottom: '5px',
    marginTop: '70px',
  },
  rightOptionContainer: {
    alignItems: 'center',
    display: 'flex',
    marginTop: '20px',
  },
  rightOptionIcon: {
    height: '24px',
    marginRight: '24px',
    width: '24px',
  },
  rightOptionTypography: {
    '&:hover': {
      textDecoration: 'underline',
    },
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: '14px',
    lineHeight: '24px',
    textDecoration: 'none',
  },
  typographyRightOptionTitle: {
    color: '#172B4D',
    fontSize: '16px',
    lineHeight: '21px',
  },
  typographyRightSubtitle: {
    color: '#172B4D',
    fontSize: '12px',
    lineHeight: '18px',
    marginBottom: '30px',
  },
  typographyRightTitle: {
    color: '#172B4D',
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '30px',
    marginBottom: '5px',
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <div>
      {/* Need assistance */}
      <Typography variant="h3" className={classes.typographyRightTitle}>
        Need Assistance?
      </Typography>

      <Typography className={classes.typographyRightSubtitle}>
        If you are having any trouble with uploading or locating your radiology files, please let our team know. We can assist with sourcing your radiology files on your behalf
        from your clinic
      </Typography>

      {/* Assistance options */}
      <Typography className={classes.typographyRightOptionTitle}>Assistance Options:</Typography>

      <div className={classes.rightOptionContainer}>
        <img src={IconMessage} alt="Icon Message" className={classes.rightOptionIcon} />
        <a href="mailto:info@mediphany.com" className={classes.rightOptionTypography}>
          info@mediphany.com
        </a>
      </div>

      <div className={classes.rightOptionContainer}>
        <img src={IconPhone} alt="Icon Phone" className={classes.rightOptionIcon} />
        <span className={classes.rightOptionTypography}>(888) 699-2977</span>
      </div>

      <div className={classes.rightOptionContainer}>
        <img src={IconFaq} alt="Icon FAQ" className={classes.rightOptionIcon} />
        <a href="#faq" className={classes.rightOptionTypography}>
          <span className={classes.rightOptionTypography}>Read our FAQs</span>
        </a>
      </div>
    </div>
  );
};
